module.exports = __webpack_public_path__ + "static/img/4.b1f1e09f.jpg";